import { render, staticRenderFns } from "./RepeatGroup.vue?vue&type=template&id=54783864&scoped=true"
import script from "./RepeatGroup.vue?vue&type=script&lang=js"
export * from "./RepeatGroup.vue?vue&type=script&lang=js"
import style0 from "./RepeatGroup.vue?vue&type=style&index=0&id=54783864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54783864",
  null
  
)

export default component.exports